import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Logo } from "@/components/atoms/logo";
import { Translator } from "@/components/i18n";
import { AuthLogin } from "@/components/molecules/auth";

import { useQuery } from "@/hooks/query";
import { useAuth } from "@/client/api";
import { GenAiContext } from "@/client/context";


export default function Login() {
  const query = useQuery();
  const { data: config, setAccessToken, user } = useAuth();
  const [error, setError] = useState("");
  const apiClient = useContext(GenAiContext);

  const navigate = useNavigate();

  const handleHeaderAuth = async () => {
    try {
      const json = await apiClient.headerAuth();
      setAccessToken(json.access_token);
      navigate("/");
    } catch (error: any) {
      setError(error.message);
    }
  };

  const handlePasswordLogin = async (
    username: string,
    password: string,
    callbackUrl: string
  ) => {
    try {
      const json = await apiClient.passwordAuth({
        username,
        password,
      });
      setAccessToken(
        json.data.token.access_token,
        json.data.token.refresh_token
      );
      navigate(callbackUrl);
    } catch (error: any) {
      setError(error.message);
    }
  };

  useEffect(() => {
    setError(query.get("error") || "");
  }, [query]);

  useEffect(() => {
    if (!config) {
      return;
    }
    if (!config.requireLogin) {
      navigate("/");
    }
    if (config.headerAuth) {
      handleHeaderAuth();
    }
    if (user) {
      navigate("/");
    }
  }, [config, user]);

  return (
    <>
      <AuthLogin
        title={<Translator path="components.molecules.auth.authLogin.title" />}
        subTitle={<Translator path="components.molecules.auth.authLogin.subTitle" />}
        error={error}
        callbackUrl="/"
        providers={config?.oauthProviders || []}
        onPasswordSignIn={config?.passwordAuth ? handlePasswordLogin : undefined}
        renderLogo={<Logo style={{ maxHeight: "90px" }} />}
      />
    </>
  );
}
